import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import {  login } from '../../store/user_slice';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { MAIN_URL } from '../../config/utils';
import { message } from 'antd';
import './styles.css'
import { useTranslation } from 'react-i18next';
import instance from '../../config/axios';
import { getAboutMe } from '../../store/about_me';
import { FaArrowLeftLong } from 'react-icons/fa6';
import Arbitrator_new_logo_eng from '../../assets/images/new-logo-white.svg';
import Arbitrator_new_logo_ru from '../../assets/images/new-logo-ru-white.svg';
import Arbitrator_new_logo_uz from '../../assets/images/new-logo-uz-white.svg';

const LoginPage: React.FC = () => {
  const { t } = useTranslation()
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const dispatch = useDispatch();
  const navigate = useNavigate()

  const active_lang = localStorage.getItem('i18lang')

  const handleLogin = async () => {
    try {
      const response = await axios.post(`${MAIN_URL}/users/auth`, { email, password}, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response?.status === 200) {
        console.log('LoginResponse', response)
        dispatch(login(response.data));
        navigate('/my-information')
        localStorage?.setItem('access_token', response?.data?.accessToken)
        message.success(`${t('You are successfully logged in!')}`);
        
        const url = `/users/about_me`;
        const about_me = await instance({ url, method: "POST", data: {}});
        about_me?.data && dispatch(getAboutMe(about_me?.data))
      } else {
        navigate('/login')
        message.error(`${t('Login error!')}`);
      }
    } catch (error) {
      navigate('/login')
      message.error(`${t('An error occurred while logging in. Please try again later')}`);
    }
  };

  return (
    <div className="login_page bg-main_color min-h-screen text-white w-full lg:px-20 sm:px-10 px-5 relative">
      <div className="max-w-[1681px] mx-auto relative max-sm:z-20">
        <div className="sm:pt-[30px]">
          <Link to='/' className='lg:block sm:hidden flex items-center justify-center'>
            {
              active_lang == "uz" ? <img src={Arbitrator_new_logo_uz} alt="logo" className="w-[210px] h-[180px] mr-5" /> : active_lang == "ru" ? <img src={Arbitrator_new_logo_ru} alt="logo" className="w-[210px] h-[180px] mr-5" /> : <img src={Arbitrator_new_logo_eng} alt="logo" className="w-[210px] h-[180px] mr-5" />
            }
          </Link>
          <div className='sm:flex lg:hidden hidden justify-between items-center sm:px-10 px-5'>
            <Link to={"/"}>
              <img src={Arbitrator_new_logo_eng} alt="logo" className="w-[210px] h-[180px] mr-5" />
            </Link>
            <Link to={""} className=' rounded-3xl w-[69px] h-[62px] flex items-center justify-center bg-[#D9D9D94D]'>
              <FaArrowLeftLong size={30} color='white' onClick={() => navigate(-1)}/>
            </Link>
          </div> 
            <div className="w-[500px] max-sm:w-full px-3 ml-auto max-lg:mx-auto lg:mt-[10%] sm:mt-[calc(100vh-650px)] mt-[10%]">
              <h2 className="text-[40px] font-bold">{t('Welcome!')}</h2>
              <p className="font-semibold text-lg mb-8">{t('Login in to your Account')}</p>
              <div className='w-full flex flex-col items-end'>
                <input required type="text" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" className='w-full mb-4 rounded-md h-[40px] py-2 px-3 focus:border-none outline-none text-[#29487E]' />
                <input required type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" className='w-full mb-4 rounded-md h-[40px] py-2 px-3 focus:border-none outline-none text-[#29487E]' />
                <button onClick={handleLogin} className="w-full bg-main_color border h-[40px] text-[20px] py-0 border-solid border-white text-white font-bold rounded">{t('Login')}</button>
                <Link to={'/enter_email'} className="font-medium mr-3 mt-1">{t('Forgot Password')}</Link>
              </div>
              <span>{t('Don’t have an account?')} <Link to={'/register'} className="font-bold">{t('Create an account')}</Link></span>
            </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;